import React from "react";
import styles from "../WorkSpaceItemList.module.css";
import { useTranslation } from "react-i18next";
import {TagName} from "../../../model/Tags"
import { useModifiedBy } from "../ResizeStyles/WorkSpaceItemListStyles/ModifiedBy";
import Btn, { TypeStyle } from "../../../components/Button/Btn";
import { tags } from "../WorkSpaceItemListStyle/ColumnStandard";
import { Typography } from "@mui/material";
import { EnumPermissionTypeNone } from "../../../enums/EnumPermissionTypeNone";
import EmptyTag from "./Components/TagField/EmptyTag";

interface TagsFieldProps {
    itemType:string;
    boxLayout:boolean;
    onClickTag:() => void;
    tagInternal:TagName[] | undefined;
    permissionType?: number;
}

const TagsField: React.ForwardRefExoticComponent<TagsFieldProps> =
	React.forwardRef(({itemType,boxLayout,onClickTag, tagInternal, permissionType }, ref: React.Ref<HTMLLIElement>) => {

    const { t, i18n } = useTranslation();
    
    const firstTagName: string|undefined = tagInternal == undefined ? undefined : tagInternal.length == 0 ? undefined : tagInternal[0].name;
    const tagLength: number =tagInternal == undefined ? 0 : tagInternal.length - 1;

    const modifiedBy = useModifiedBy();

    return (
        <div  className={`${boxLayout?modifiedBy.myDiv:modifiedBy.default}`}
          style={{
            gridArea:tags
          }}
        >
             {itemType != "folder" ? (
                 tagInternal != undefined ? (
                  tagInternal.length > 0 ?(
                    <div style={{display:"flex"}}>
                        <Btn
                            text={firstTagName}
                            style={TypeStyle.EditTagButton}
                            onClick={(permissionType == EnumPermissionTypeNone.edit || permissionType == EnumPermissionTypeNone.organize) ? onClickTag : undefined}
                        />
                        <div className={styles.lengthTag}>
                          {
                            tagLength != 0 && (                                            
                              <div>+{tagLength}</div>
                            )                      
                          }
                        </div>
                    </div> 
                  ):((permissionType == EnumPermissionTypeNone.edit || permissionType == EnumPermissionTypeNone.organize) ? 
                    <div style={{ display: "flex" }}>
                      <Btn
                        text={t("tag.add")}
                        style={TypeStyle.AddTagButton}
                        onClick={onClickTag}
                      />
                    </div> : <EmptyTag/>
                    )            
                ):( (permissionType == EnumPermissionTypeNone.edit || permissionType == EnumPermissionTypeNone.organize) ?
                  <div style={{display:"flex"}}> 
                      <Btn
                        text={t("tag.add")}
                        style={TypeStyle.AddTagButton}
                        onClick={onClickTag}
                      />       
                  </div> : <EmptyTag/>
                )              
              ) : 
              <EmptyTag/>
              }
        </div>        
    );
});

    
export default TagsField;
